import React from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import LazyLoad from "react-lazyload";
const Reflections = () => {
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Activity</li>
          <li>Reflections</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Reflections</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/HTSJ/public/Images/coming-soon.jpg"
                  className="img-fluid mx-auto d-block cm"
                  alt="HTS"
                />
              </LazyLoad>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reflections;
